import {Column} from './column';
import {Todo} from '../enums/todo.enum';

export class SelectionOption {
  column: Column;
  todo: Todo;
  value1: string;
  value2: string;
}
